import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import { SEO } from "@/components/SEO";
import { useAuth } from "@/context/AuthContext";
import { apiFetch } from "@/lib/api";
import { rememberSignupCta, rememberRef } from "@/lib/membership";
import { FOUNDER_DISCLAIMER } from "@/components/FounderShare";
import { track } from "@/lib/engagement";

export default function Founder() {
  const { user } = useAuth();
  const [open, setOpen] = useState(true);
  useEffect(() => {
    track("founder_page_viewed");
    rememberRef(new URLSearchParams(window.location.search).get("ref"));
    apiFetch(`/founder/status`, { auth: false }).then((r) => setOpen(r.open)).catch(() => {});
  }, []);
  return (
    <div data-testid="founder-page" className="max-w-[760px] mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-14 pb-16">
      <SEO title="Founder Readoo" description="Founder Readoo è il riconoscimento per chi si registra a Readoo nella sua fase iniziale." />
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand text-onBrand text-[11px] font-mono font-bold uppercase tracking-wider">
        <Crown size={12} /> Founder Readoo
      </span>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl font-semibold leading-tight text-onSurface">I primi lettori di Readoo</h1>
      <p className="mt-4 text-base sm:text-[17px] leading-relaxed text-onSurfaceSecondary">
        Readoo ti porta ogni giorno le notizie importanti, scritte in modo chiaro, e un feed costruito sui tuoi interessi.
        Chi si registra in questa fase iniziale riceve il badge Founder Readoo nel proprio profilo.
      </p>
      <p data-testid="founder-page-perks" className="mt-3 text-base sm:text-[17px] leading-relaxed font-semibold text-onSurface">
        I Founder hanno accesso prioritario e in anteprima alle novità di Readoo, quando disponibili.
      </p>
      {user ? (
        <Link to="/profilo" data-testid="founder-page-profile" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand text-onBrand text-sm font-bold uppercase tracking-wide hover:bg-brandSecondary transition-colors">
          Vai al tuo Readoo <ArrowRight size={15} />
        </Link>
      ) : (
        <Link to="/registrati" data-testid="founder-page-register" onClick={() => rememberSignupCta("founder")}
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand text-onBrand text-sm font-bold uppercase tracking-wide hover:bg-brandSecondary transition-colors">
          {open ? "Registrati e diventa Founder" : "Registrati gratis"} <ArrowRight size={15} />
        </Link>
      )}
      {!open && <p data-testid="founder-page-closed" className="mt-3 text-sm text-subtle">Le iscrizioni come Founder sono chiuse, ma Readoo resta gratuito per tutti.</p>}
      <p data-testid="founder-page-disclaimer" className="mt-8 text-xs text-subtle">
        {FOUNDER_DISCLAIMER} <Link to="/termini#founder" data-testid="founder-page-terms" className="underline hover:text-brand">Leggi i termini</Link>
      </p>
    </div>
  );
}
